import './index.scss';

import '@splidejs/splide/css/core';

import Splide from '@splidejs/splide';

class InfoList3 {
    constructor(root) {
        this.root = root;
        this.navLocked = false;
        this.navUnlockTimer = null;

        const splide = this.root.querySelector('.splide');
        if (!splide) {
            return;
        }

        // Same idea as Image Slider: slide (no loop), stop at ends.
        // perMove: 1 — always advance one slide, even when multiple are visible.
        // perPage: 1 → 2@768 → 3@992 → 4@1644 → 5@1920 (stay at 3 through 1280).
        this.splide = new Splide(splide, {
            gap: 0,
            pagination: false,
            mediaQuery: 'min',
            perPage: 1,
            perMove: 1,
            breakpoints: {
                768: {
                    perPage: 2,
                    perMove: 1,
                },
                992: {
                    perPage: 3,
                    perMove: 1,
                },
                1644: {
                    perPage: 4,
                    perMove: 1,
                },
                1920: {
                    perPage: 5,
                    perMove: 1,
                },
            },
        });

        this.splide.mount();

        this.buttonPrev = this.root.querySelector('.splide__arrow--prev');
        this.buttonNext = this.root.querySelector('.splide__arrow--next');

        this.bindArrow(this.buttonPrev);
        this.bindArrow(this.buttonNext);

        this.splide.on('moved resized updated refreshed', () => {
            this.clearNavUnlockTimer();
            this.navLocked = false;
        });

        // Splide toggles disabled at ends; blur so focus does not linger on a hidden control.
        this.splide.on('arrows:updated', (prev, next) => {
            this.blurIfDisabled(prev);
            this.blurIfDisabled(next);
        });
    }

    bindArrow(button) {
        if (!button) {
            return;
        }

        // Capture phase: gate rapid double click/tap before Splide's own handler.
        button.addEventListener('click', (event) => {
            this.onArrowClick(event);
        }, true);
        button.addEventListener('dblclick', (event) => {
            event.preventDefault();
        });
    }

    onArrowClick(event) {
        if (this.navLocked || this.splide.Components.Controller.isBusy()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }

        this.navLocked = true;
        this.clearNavUnlockTimer();
        this.navUnlockTimer = window.setTimeout(() => {
            this.navUnlockTimer = null;
            this.navLocked = false;
        }, 450);
    }

    clearNavUnlockTimer() {
        if (this.navUnlockTimer !== null) {
            window.clearTimeout(this.navUnlockTimer);
            this.navUnlockTimer = null;
        }
    }

    blurIfDisabled(button) {
        if (button && button.disabled && document.activeElement === button) {
            button.blur();
        }
    }
}

window.app.run(() => {
    document.querySelectorAll('.infolist3').forEach((node) => {
        new InfoList3(node);
    });
});
